const BASE = '/api'

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message)
  }
}

export async function apiFetch<T>(
  path: string,
  options: RequestInit & { token?: string; adminSecret?: string } = {}
): Promise<T> {
  const { token, adminSecret, ...init } = options
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(init.headers as Record<string, string>),
  }
  if (token) headers['Authorization'] = `Bearer ${token}`
  if (adminSecret) headers['X-Admin-Secret'] = adminSecret

  const res = await fetch(`${BASE}${path}`, { ...init, headers })
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText })) as { error?: string }
    throw new ApiError(res.status, err.error ?? res.statusText)
  }
  return res.json() as Promise<T>
}
